export default "__VITE_PUBLIC_ASSET__9b703566__"